import Es6Promise from "es6-promise";
Es6Promise.polyfill();

import "babel-polyfill";
import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import App from "./App.vue";

import axios from "axios";
import router from "./router";
import i18n from "./plugins/i18n";
import FlagIcon from "vue-flag-icon";
import "vuetify/dist/vuetify.min.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/vendor/fontawesome/css/all.min.css";

import store from "./store";
import VueCryptojs from "vue-cryptojs";
import vuetify from "./plugins/vuetify";
import Cookies from "js-cookie";
import lineClamp from "vue-line-clamp";
import VueMask from "v-mask";
import AsyncComputed from "vue-async-computed";
import "./assets/styles/global.css";
import Breadcrumbs from "./components/Breadcrumbs.vue";

Vue.config.productionTip = false;
axios.defaults.headers.common["Authorization"] =
  "Bearer " + Cookies.get("tokenProduct");
Vue.prototype.$http = axios;
Vue.config.productionTip = false;

window.$ = window.jQuery = require("jquery");
Vue.component("Breadcrumbs", Breadcrumbs);
Vue.use(vuetify);
Vue.use(VueMask);
Vue.use(FlagIcon);
Vue.use(VueCryptojs);
Vue.use(lineClamp);
Vue.use(AsyncComputed);
Vue.mixin({
  methods: {
    getoffset() {
      var offset = new Date().getTimezoneOffset();
      console.log("offset", offset);
      return offset;
    }
  }
});
new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
